export const NAVBAR_ANIMATION_DURATION = 0.2;

// @docs https://easings.net/#easeOutQuint
export const EASE_OUT_QUINT = {
  duration: 1,
  ease: [0.22, 1, 0.36, 1],
};

export const SPRING_TRANSITION = {
  type: 'spring',
  stiffness: 400,
  damping: 50,
};
